<template>
  <el-drawer
  :title="$t('common.reports')"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <el-row>
      <h6>Sélection du rapport</h6>
      <el-select v-model="reportFilters.type" placeholder="Select" @change="handleReportSelection">
        <el-option
          v-for="item in myReports"
          :key="item.code"
          :label="item.label"
          :value="item.code">
        </el-option>
      </el-select>
    </el-row>
    <div v-if="!propertiesSelectionDisable && !isStandardPriceList">
      <el-row >
        <h6>Option de publication WEB</h6>
        <el-checkbox  size="mini" :label="true" :disabled="propertiesSelectionDisable" v-model="reportFilters.puidPublished" border>Publié</el-checkbox>
        <el-checkbox  size="mini" :label="true" :disabled="propertiesSelectionDisable" v-model="reportFilters.puidUnpublished" border>Non publié</el-checkbox>
      </el-row>
      <el-row class="mt-5">
        <h6>Options d'affichage</h6>
        <el-checkbox  size="mini" :label="true" :disabled="propertiesSelectionDisable" v-model="reportFilters.showUvc" border>UVC</el-checkbox>
        <el-checkbox  size="mini" :label="true" :disabled="propertiesSelectionDisable" v-model="reportFilters.showVolume" border>Format/volume</el-checkbox>
        <el-checkbox  size="mini" :label="true" :disabled="propertiesSelectionDisable" v-model="reportFilters.showVintage" border>Millésime</el-checkbox>
      </el-row>
      <el-row class="mt-5">
        <h6>Affichage des prix</h6>
        <el-checkbox  size="mini" :disabled="reportFilters.withoutPrices == true || propertiesSelectionDisable" :label="true" v-model="reportFilters.taxesIn" border>Avec taxes</el-checkbox>
        <el-checkbox  size="mini" :disabled="reportFilters.withoutPrices == true || propertiesSelectionDisable"  :label="true" v-model="reportFilters.taxesOut" border>Sans taxes</el-checkbox>
        <el-checkbox  size="mini" :label="true" :disabled="propertiesSelectionDisable" v-model="reportFilters.withoutPrices" border>Sans prix</el-checkbox>
      </el-row>
      <el-row class="mt-5">
        <h6>Disponibilité des produits</h6>
        <el-checkbox  size="mini" :label="true" :disabled="propertiesSelectionDisable" v-model="reportFilters.available" border>Disponible</el-checkbox>
        <el-checkbox  size="mini" :label="true" :disabled="propertiesSelectionDisable" v-model="reportFilters.upcoming" border>À venir</el-checkbox>
        <el-checkbox  size="mini" :label="true" :disabled="propertiesSelectionDisable" v-model="reportFilters.showQuantity" border>Afficher les quantitées</el-checkbox>
      </el-row>
      <el-row class="mt-5">
        <h6>Pays d'origines</h6>
        <el-select v-model="reportFilters.countries" :disabled="propertiesSelectionDisable" placeholder="Select" :clearable="true" :multiple="true">
          <el-option
            v-for="item in countries"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-row>
      <el-row class="mt-5">
        <h6>Type de produit</h6>
        <el-select v-model="reportFilters.productTypes" :disabled="propertiesSelectionDisable" placeholder="Select" :clearable="true" :multiple="true">
          <el-option
            v-for="item in productTypes"
            :key="item.id"
            :label="item.name[lang]"
            :value="item.id">
          </el-option>
        </el-select>
      </el-row>
    </div>
    <div v-if="isStandardPriceList" class="standard-price-list-options">
      <el-row class="mt-15">
        <h6>Gabarit</h6>
        <el-radio-group v-model="reportFilters.priceListTemplate" size="mini">
          <el-radio label="CLASSIC" border>Classique</el-radio>
          <el-radio label="MODERN" border>Moderne</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="mt-15">
        <h6>Orientation</h6>
        <el-radio-group v-model="reportFilters.priceListOrientation" size="mini">
          <el-radio label="LANDSCAPE" border>Paysage</el-radio>
          <el-radio label="PORTRAIT" border>Portrait</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="mt-15">
        <h6>Produits à afficher</h6>
        <el-checkbox size="mini" :label="true" v-model="reportFilters.available" border>Afficher les produits disponibles</el-checkbox>
        <el-checkbox size="mini" :label="true" v-model="reportFilters.upcoming" border>À venir</el-checkbox>
      </el-row>
      <el-row class="mt-15">
        <h6>Affichage des informations</h6>
        <el-checkbox size="mini" :label="true" v-model="reportFilters.showSku" border>
          Afficher le SKU
        </el-checkbox>
        <el-checkbox size="mini" :label="true" v-model="reportFilters.showAvailableQuantity" border>
          Afficher la quantité disponible à la vente
        </el-checkbox>
      </el-row>
      <el-row class="mt-10">
        <el-checkbox size="mini" :label="true" v-model="reportFilters.showProductType" border>Type / sous-type</el-checkbox>
        <el-checkbox size="mini" :label="true" v-model="reportFilters.showAppellation" border>Appellation</el-checkbox>
        <el-checkbox size="mini" :label="true" v-model="reportFilters.showGrapes" border>Cépages</el-checkbox>
      </el-row>
      <el-row class="mt-15">
        <h6>Pays d'origine</h6>
        <el-select
          v-model="reportFilters.countries"
          placeholder="Tous les pays"
          :clearable="true"
          :multiple="true"
          filterable
          style="width: 100%">
          <el-option
            v-for="item in countries"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-row>
      <el-row class="mt-15">
        <h6>Types / sous-types de produit</h6>
        <el-select
          v-model="reportFilters.productTypeCombinations"
          placeholder="Toutes les combinaisons"
          :clearable="true"
          :multiple="true"
          filterable
          style="width: 100%">
          <el-option
            v-for="item in productTypeCombinationOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-row>
      <el-row class="mt-15">
        <h6>Prix à afficher</h6>
        <el-radio-group v-model="reportFilters.priceMode" size="mini">
          <el-radio label="STANDARD" border>Prix Standards</el-radio>
          <el-radio label="CUSTOMER_CLASS" border>Prix selon la classe client</el-radio>
        </el-radio-group>
      </el-row>
      <el-row v-if="reportFilters.priceMode === 'STANDARD'" class="mt-10">
        <el-checkbox size="mini" :label="true" v-model="reportFilters.showParticularPrice" border>Prix particulier</el-checkbox>
        <el-checkbox size="mini" :label="true" v-model="reportFilters.showLicensedPrice" border>Prix licencié</el-checkbox>
      </el-row>
      <el-row v-if="reportFilters.priceMode === 'CUSTOMER_CLASS'" class="mt-10">
        <h6>Classe client</h6>
        <el-select
          v-model="reportFilters.customerClasses"
          placeholder="Sélectionner une classe client"
          :clearable="true"
          filterable
          style="width: 100%">
          <el-option
            v-for="item in customerClasses"
            :key="item.id"
            :label="getCustomerClassLabel(item)"
            :value="item.id">
          </el-option>
        </el-select>
      </el-row>
    </div>
    <div v-if="showCustomerClassesFilter" class="mt-5">
      <el-row>
        <h6>Classes clients</h6>
        <el-select
          v-model="reportFilters.customerClasses"
          placeholder="Selectionner"
          :clearable="true"
          filterable
          style="width: 100%">
          <el-option
            v-for="item in customerClasses"
            :key="item.id"
            :label="getCustomerClassLabel(item)"
            :value="item.id">
          </el-option>
        </el-select>
      </el-row>
    </div>
    <div v-if="showAvailabilityFilter" class="mt-5">
      <el-row>
        <h6>Disponibilité des produits</h6>
        <el-checkbox size="mini" :label="true" v-model="reportFilters.available" border>Disponible</el-checkbox>
        <el-checkbox size="mini" :label="true" v-model="reportFilters.upcoming" border>À venir</el-checkbox>
      </el-row>
      <el-row class="mt-5">
        <h6>Affichage des dates (produits à venir)</h6>
        <el-radio-group size="mini" v-model="reportFilters.showUpcomingDates" :disabled="reportFilters.upcoming !== true">
          <el-radio-button :label="false">Masquer les dates</el-radio-button>
          <el-radio-button :label="true">Afficher les dates</el-radio-button>
        </el-radio-group>
      </el-row>
    </div>
    <el-row class="mt-20">
      <el-button type="primary"  @click="handleDownloadReport">Générer le rapport</el-button>
    </el-row>
    
  </div>
  <WatingDialog :visible="globalInventoryReportLoading"></WatingDialog>
</el-drawer>
</template>
<script>
import systemAPI from '@/services/API/system'
import cmsAPI from '@/services/API/cmsAPI'
import WatingDialog from '@/components/waiting-dialog'
import { mapActions, mapState, mapGetters } from 'vuex';
import axios from 'axios';
import dayjs from 'dayjs';
export default {
  name: 'inventory-report-drawer',
	props: {
    inventoryId : {type : Number},
    visible : {type : Boolean},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      reportFilters : {
        puidPublished: false,
        puidUnpublished: false,
        showQuantity: false,
        withoutPrices: false,
        showUvc : true,
        showVolume: true,
        showVintage: true,
        taxesIn: false,
        taxesOut: true,
        type: 'PRODUCT_LISTING',
        countries: [],
        productTypes: [],
        productTypeCombinations: [],
        available: true,
        upcoming: true,
        showUpcomingDates: false,
        customerClasses: null,
        showSku: true,
        showAvailableQuantity: true,
        showProductType: false,
        showAppellation: false,
        showGrapes: false,
        priceListTemplate: 'CLASSIC',
        priceListOrientation: 'LANDSCAPE',
        priceMode: 'STANDARD',
        showParticularPrice: true,
        showLicensedPrice: true,
      },
      customReports: [],
      propertiesSelectionDisable: false,
      reports : [
        { code: 'STANDARD_PRICE_LIST', label: "Liste de prix" },
        { code: 'PRODUCT_LISTING', label: "Liste des produits formatée" }, 
        { code: 'INVENTORIES', label: "Liste des produits Excel"},
      ],
      countries: [],
      countriesLoading: false,
      productTypesLoading: false,
      productTypes: [],
      model : {
        columns : [],
      },
      window: {
        width: 0,
        height: 0
      }
    };
  },components: {
    WatingDialog,
  },
  watch : {

  },
	methods: {
    handleReportSelection(report) {
      const myReport = _.find(this.myReports, r => r. code === report);
      if (myReport == null) return;

      if (myReport.resource === 'CUSTOM_EXTERNAL_REPORT' || myReport.code === 'SHOPIFY') {
        this.propertiesSelectionDisable = true;
      } else {
        this.propertiesSelectionDisable = false;
      }

      if (this.showCustomerClassesFilter === false) {
        this.reportFilters.customerClasses = null;
      }

      if (this.showAvailabilityFilter === false) {
        this.reportFilters.available = true;
        this.reportFilters.upcoming = true;
        this.reportFilters.showUpcomingDates = false;
      }

      if (this.isStandardPriceList) {
        this.reportFilters.available = true;
        this.reportFilters.upcoming = false;
        this.reportFilters.showSku = true;
        this.reportFilters.showAvailableQuantity = true;
        this.reportFilters.showProductType = false;
        this.reportFilters.showAppellation = false;
        this.reportFilters.showGrapes = false;
        this.reportFilters.priceListTemplate = 'CLASSIC';
        this.reportFilters.priceListOrientation = 'LANDSCAPE';
        this.reportFilters.countries = [];
        this.reportFilters.productTypeCombinations = [];
        this.reportFilters.priceMode = 'STANDARD';
        this.reportFilters.showParticularPrice = true;
        this.reportFilters.showLicensedPrice = true;
        this.reportFilters.customerClasses = null;
      }
      
    },
    getCustomerClassLabel(customerClass) {
      const code = _.get(customerClass, 'code', '');
      const description = _.get(customerClass, 'description', '');
      if (_.isEmpty(description)) return code;
      return `${code} - ${description}`;
    },
    handleExcelDownloadReport(myReport){
        const customerClassId = this.reportFilters.customerClasses;
        const customerClasses = customerClassId != null ? [customerClassId] : [];
        let show = null;
        if (this.reportFilters.available === true && this.reportFilters.upcoming === false) {
          show = 'AVAILABLE';
        } else if (this.reportFilters.available === false && this.reportFilters.upcoming === true) {
          show = 'UPCOMING';
        } else if (this.reportFilters.available === true && this.reportFilters.upcoming === true) {
          show = 'AVAILABLE_UPCOMING';
        }

      const extension = myReport.type === "CUSTOM_EXTERNAL_EXCEL_REPORT" ? "xlsx": "pdf"
      const params = {
          type: myReport.type,
          format: myReport.type === "CUSTOM_EXTERNAL_EXCEL_REPORT" ? "EXCEL": "PDF",
          code: myReport.code,
          shortId: myReport.shortId,
          inventoryId: this.inventoryId,
            show,
            showUpcomingDates: this.reportFilters.showUpcomingDates === true,
          customerClassId,
          customerClasses,
          customer_classes: customerClasses,
          filename: `${_.kebabCase(myReport.label)}-${dayjs().format('YYYY-MM-DD')}.${extension}`,
        };
        this.downloadInventoryReport(params);
    },
    handleDownloadReport(){
      const myReport = _.find(this.myReports, r => r. code === this.reportFilters.type);
      if (this.isStandardPriceList) {
        return this.handleStandardPriceListDownload();
      }
      if (myReport.resource === 'CUSTOM_EXTERNAL_REPORT') {
        return this.handleExcelDownloadReport(myReport);
      }
      if (this.reportFilters.type == null) {

      } else {

        let webPublished = undefined;
        if (this.reportFilters.puidPublished === true && this.reportFilters.puidUnpublished === false) {
          webPublished= true;
        } else if (this.reportFilters.puidPublished === false && this.reportFilters.puidUnpublished === true) {
          webPublished= false;
        }

        let show = null;
        if (this.reportFilters.available === true && this.reportFilters.upcoming === false){
          show = "AVAILABLE"
        } else if (this.reportFilters.available === false && this.reportFilters.upcoming === true){
          show = "UPCOMING"
        } else if (this.reportFilters.available === true && this.reportFilters.upcoming === true){
          show = "AVAILABLE_UPCOMING"
        }

        let taxes = null;

        if (this.reportFilters.taxesIn === true && this.reportFilters.taxesOut === false) {
          taxes = 'IN';
        } else if (this.reportFilters.taxesIn === false && this.reportFilters.taxesOut === true) {
          taxes = 'OUT';
        } else if (this.reportFilters.taxesIn === true && this.reportFilters.taxesOut === true) {
          taxes = 'IN_OUT';
        }

        let showPrices = this.reportFilters.withoutPrices === true ? false : true;
        
        const params = {
          webPublished,
          showUvc: this.reportFilters.showUvc,
          showVintage: this.reportFilters.showVintage,
          showVolume: this.reportFilters.showVolume,
          showQuantity: this.reportFilters.showQuantity,
          showPrices,
          type: this.reportFilters.type,
          inventoryId: this.inventoryId,
          show,
          taxes,
          countries: this.reportFilters.countries,
          productTypes: this.reportFilters.productTypes,
          format: this.reportFilters.type === 'INVENTORIES' ? 'CSV' : 'PDF',
          filename: `${this.getCurrentInventoryName}-${dayjs().format('YYYY-MM-DD')}.${this.reportFilters.type === 'INVENTORIES' ? 'xlsx' : 'pdf'}`
        };
        this.downloadInventoryReport(params);
      }
    },
    handleStandardPriceListDownload () {
      if (this.reportFilters.available !== true && this.reportFilters.upcoming !== true) {
        this.$message.warning('Sélectionnez au moins une disponibilité de produit.');
        return;
      }

      if (this.reportFilters.priceMode === 'CUSTOMER_CLASS' && this.reportFilters.customerClasses == null) {
        this.$message.warning('Sélectionnez une classe client.');
        return;
      }

      if (this.reportFilters.priceMode === 'STANDARD'
        && this.reportFilters.showParticularPrice !== true
        && this.reportFilters.showLicensedPrice !== true) {
        this.$message.warning('Sélectionnez au moins un prix standard.');
        return;
      }

      this.downloadInventoryReport({
        type: 'STANDARD_PRICE_LIST',
        inventoryId: this.inventoryId,
        available: this.reportFilters.available,
        upcoming: this.reportFilters.upcoming,
        showSku: this.reportFilters.showSku,
        showAvailableQuantity: this.reportFilters.showAvailableQuantity,
        showProductType: this.reportFilters.showProductType,
        showAppellation: this.reportFilters.showAppellation,
        showGrapes: this.reportFilters.showGrapes,
        priceListTemplate: this.reportFilters.priceListTemplate,
        priceListOrientation: this.reportFilters.priceListOrientation,
        countries: this.reportFilters.countries,
        productTypeCombinations: this.reportFilters.productTypeCombinations,
        priceMode: this.reportFilters.priceMode,
        showParticularPrice: this.reportFilters.showParticularPrice,
        showLicensedPrice: this.reportFilters.showLicensedPrice,
        customerClassId: this.reportFilters.priceMode === 'CUSTOMER_CLASS'
          ? this.reportFilters.customerClasses
          : null,
        format: 'PDF',
        filename: `liste-prix-${dayjs().format('YYYY-MM-DD')}.pdf`,
      });
    },
    fetchProductTypes (){
      this.productTypesLoading = true;
      return cmsAPI.fetchProductTypes()
        .then(specificTypes=>{
          this.productTypes = specificTypes;
          this.productTypesLoading = false;

        })
    },
    fetchCountries () {
      this.countriesLoading = true;
      return systemAPI.fetchCountriesV2('products')
        .then((countries) => {
          this.countriesLoading = false;
          this.countries = countries;
        }).catch((err) => {
          this.countriesLoading = false;
          console.log(err);
        })
    },
    open(){
      this.fetchCountries();
      this.fetchProductTypes();
      this.fetchCustomerClasses();
      this.model.columns = this.columns;
    },
    fetchReportsDefinition(){
      this.loading = true;
      return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sys/reports")
        .then(response=>{
          const reports = _.filter(response.data, r => r.resource === 'CUSTOM_EXTERNAL_REPORT' && r.disabled === false);
          _.forEach(reports, r => {
            this.customReports.push({ code: r.code, label: r.title , shortId: r.report_short_id, resource: r.resource, inventoryId: r.fk_inventory_id, type: r.type, reportsConfig: _.get(r, 'reports_config', _.get(r, 'reportsConfig')) });
          })
          this.loading = false;
        })
    },
    handleColumnsChange () {
      this.setColumns(this.model.columns);
    },
    handleClose(){
      this.reportFilters.type = null;
      this.reportFilters.customerClasses = null;
      this.reportFilters.available = true;
      this.reportFilters.upcoming = true;
      this.reportFilters.showUpcomingDates = false;
      this.reportFilters.showSku = true;
      this.reportFilters.showAvailableQuantity = true;
      this.reportFilters.showProductType = false;
      this.reportFilters.showAppellation = false;
      this.reportFilters.showGrapes = false;
      this.reportFilters.priceListTemplate = 'CLASSIC';
      this.reportFilters.priceListOrientation = 'LANDSCAPE';
      this.reportFilters.countries = [];
      this.reportFilters.productTypeCombinations = [];
      this.reportFilters.priceMode = 'STANDARD';
      this.reportFilters.showParticularPrice = true;
      this.reportFilters.showLicensedPrice = true;
      this.$emit('close');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ...mapActions('inventoryProducts', ['downloadInventoryReport', 'setColumns']),
    ...mapActions('controlData', ['fetchCustomerClasses'])
	},
	computed: {
    myReports() {
      const myCustomReports = _.filter(this.customReports, r => r.inventoryId == null || r.inventoryId === this.inventoryId);
      return _.union(this.reports, myCustomReports)
    },
    lang(){
      return this.$i18n.locale
    },
    productName(){
      if(this.selectedProduct==null) return "";
      else return this.selectedProduct.name;
    },
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "30%";
      }else{
        return "100%"
      }
    },
    selectedReport () {
      return _.find(this.myReports, r => r.code === this.reportFilters.type);
    },
    isStandardPriceList () {
      return this.reportFilters.type === 'STANDARD_PRICE_LIST';
    },
    productTypeCombinationOptions () {
      return _.flatMap(this.productTypes, (productType) => {
        const typeName = _.get(productType, `name.${this.lang}`)
          || _.get(productType, 'name.fr')
          || _.get(productType, 'name.en')
          || _.get(productType, 'code', '');
        const specifics = _.get(productType, 'specifics', []);
        if (_.isEmpty(specifics)) {
          return [{
            value: `${productType.id}:`,
            label: typeName,
          }];
        }
        return _.map(specifics, (specificType) => {
          const specificTypeName = _.get(specificType, `name.${this.lang}`)
            || _.get(specificType, 'name.fr')
            || _.get(specificType, 'name.en')
            || _.get(specificType, 'code', '');
          return {
            value: `${productType.id}:${specificType.id}`,
            label: `${typeName} - ${specificTypeName}`,
          };
        });
      });
    },
    showCustomerClassesFilter () {
      const selectedReport = this.selectedReport;
      if (selectedReport == null) return false;
      if (selectedReport.resource !== 'CUSTOM_EXTERNAL_REPORT') return false;
      return _.get(selectedReport, 'reportsConfig.filters.customerClasses', false) === true;
    },
    showAvailabilityFilter () {
      const selectedReport = this.selectedReport;
      if (selectedReport == null) return false;
      if (selectedReport.resource !== 'CUSTOM_EXTERNAL_REPORT') return false;
      return _.get(selectedReport, 'reportsConfig.filters.availability', false) === true;
    },
    ...mapState('inventoryProducts', ['columnsOptions', 'columns', 'globalInventoryReportLoading']),
    ...mapState('controlData', ['customerClasses']),
    ...mapGetters('inventoryProducts', ['getCurrentInventoryName'])
	},
  created(){
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
    this.fetchReportsDefinition();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

.standard-price-list-options {
  h6 {
    margin-bottom: 8px;
    width: 100%;
  }

  .el-radio {
    margin: 0 8px 8px 0;
  }
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
